/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Пангинация
 * @export
 * @interface Paginate
 */
export interface Paginate {
  /**
   *
   * @type {number}
   * @memberof Paginate
   */
  totalRecords?: number
  /**
   *
   * @type {number}
   * @memberof Paginate
   */
  total?: number
  /**
   *
   * @type {number}
   * @memberof Paginate
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof Paginate
   */
  perPage: number
  /**
   *
   * @type {number}
   * @memberof Paginate
   */
  lastPage: number
}

/**
 * Check if a given object implements the Paginate interface.
 */
export function instanceOfPaginate(value: object): value is Paginate {
  if (!('page' in value) || value['page'] === undefined) return false
  if (!('perPage' in value) || value['perPage'] === undefined) return false
  if (!('lastPage' in value) || value['lastPage'] === undefined) return false
  return true
}

export function PaginateFromJSON(json: any): Paginate {
  return PaginateFromJSONTyped(json, false)
}

export function PaginateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Paginate {
  if (json == null) {
    return json
  }
  return {
    totalRecords:
      json['totalRecords'] == null ? undefined : json['totalRecords'],
    total: json['total'] == null ? undefined : json['total'],
    page: json['page'],
    perPage: json['perPage'],
    lastPage: json['lastPage'],
  }
}

export function PaginateToJSON(value?: Paginate | null): any {
  if (value == null) {
    return value
  }
  return {
    totalRecords: value['totalRecords'],
    total: value['total'],
    page: value['page'],
    perPage: value['perPage'],
    lastPage: value['lastPage'],
  }
}
